var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 41,
    viewBox: "0 0 193 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 20.5L158.833 7.375M190 20.5L158.833 33.625M190 20.5H128.404C114.63 20.5001 101.42 22.804 91.6796 26.905L80.5427 31.595C70.8043 35.695 57.5986 37.9988 43.8283 38H3M3 3H48.1189C53.5774 2.99992 58.9824 3.4527 64.0253 4.33249C69.0681 5.21228 73.65 6.50184 77.5091 8.1275L94.7131 15.3725C98.5722 16.9982 103.154 18.2877 108.197 19.1675C113.24 20.0473 118.645 20.5001 124.103 20.5H158.833",
    stroke: "#6842D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5306fe0236362dbfd17b8aef0c57e2ae.svg";
export { ForwardRef as ReactComponent };